import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslocoModule } from '@jsverse/transloco';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { environment } from '../../../../../environments/environment';
import { ClientService } from '../../../../core/services';
import { Client } from '../../../../domain/models';
import {
    ProviderCardCollectionComponent,
    ProviderSearchComponent
} from '../../components';
import { ProviderSearch } from '../../models';
import { Provider } from '../../models/provider.model';
import { ProviderService } from '../../services/provider.service';

@Component({
    selector: 'app-provider',
    templateUrl: './provider.component.html',
    styleUrls: ['./provider.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslocoModule,
        ProviderSearchComponent,
        ProviderCardCollectionComponent,
        FlexLayoutModule
    ]
})
export class ProviderComponent implements OnInit {
    private _loading = new BehaviorSubject<boolean>(false);

    client: Client | undefined;
    providers: Provider[] | undefined;
    searchParams: ProviderSearch = new ProviderSearch();
    formattedSearchAddress: string | undefined;
    loading$ = this._loading.asObservable();

    constructor(
        private readonly _client: ClientService,
        private providerService: ProviderService,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {}

    ngOnInit(): void {
        this._client.latest.subscribe((client) => {
            this.client = client;
            this.updateBackgroundClass();
        });
    }

    private updateBackgroundClass(): void {
        const body = document.getElementsByTagName('body')[0];
        if (!this.client?.isEnabled) {
            body.classList.add('blue-background-active');
        } else {
            body.classList.remove('blue-background-active');
        }
    }

    sortProviders(sort: string) {
        this.searchParams.sort = sort;
        this.executeSearch();
    }

    searchProviders(params: ProviderSearch) {
        params.sort = this.searchParams.sort;
        this.searchParams = params;
        this.executeSearch();
    }

    private executeSearch() {
        this._loading.next(true);
        this.formattedSearchAddress = undefined;
        this.providerService
            .getProviders(this.searchParams)
            .pipe(finalize(() => this._loading.next(false)))
            .subscribe((result) => {
                this.providers = result.providers;
                this.formattedSearchAddress = result.formattedAddress;

                this.providers.forEach((provider: Provider) => {
                    // prepend API URL
                    if (provider.logoPath)
                        provider.logoPath = `${environment.apiUrl}${provider.logoPath}`;
                });
            });
    }
}
